import './App.css';
import SocialMediaWidget from './Components/Widget/SocialMediaWidget';
import UserWayWidget from './pages/UserwayWidget/UserwayWidget';
import AppRoutes from './Routes/AppRoutes';
import 'leaflet/dist/leaflet.css';

function App() {
  return (
    <>
      <AppRoutes />
      <UserWayWidget/>
      {/* <SocialMediaWidget/> */}
    </>
  );
}

export default App;
